module.exports = __webpack_public_path__ + "static/media/Asset_Analyzer_Placeholder.371f2698.pdf";